import { supabase } from "@/lib/supabase";
import { ActiveRunState, isValidRun } from "@/lib/runPersistence";

// Cross-device backup of the active run for signed-in players, synced
// periodically from useGameState (see runPersistence for the local copy).
export async function saveActiveRunRemote(
  userId: string,
  state: ActiveRunState,
): Promise<void> {
  const { error } = await supabase.from("active_runs").upsert({
    user_id: userId,
    run_state: state,
    updated_at: new Date(state.updatedAt).toISOString(),
  });
  if (error) throw error;
}

export async function loadActiveRunRemote(
  userId: string,
): Promise<ActiveRunState | null> {
  const { data, error } = await supabase
    .from("active_runs")
    .select("run_state")
    .eq("user_id", userId)
    .maybeSingle();
  if (error || !data) return null;
  // Same structural gate as the local copy. Without this, an old/partial remote
  // run (saved by a previous deploy) would be restored unchecked and then
  // re-saved locally under the current version — corrupting local state and
  // crashing on the next spin. Reject it; the next save overwrites it cleanly.
  const run = data.run_state;
  if (!isValidRun(run)) return null;
  return run;
}

export async function clearActiveRunRemote(userId: string): Promise<void> {
  await supabase.from("active_runs").delete().eq("user_id", userId);
}
